/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M10.2186 17.9099c.2929-.2929.7687-.2938 1.0616-.0009a.75.75 0 0 1 0 1.0607L6.2498 24l-5.0299-5.0298A.75.75 0 1 1 2.28 17.909l3.2198 3.2197V7.1901c0-.4142.3358-.7508.75-.7508a.75.75 0 0 1 .75.75v13.9394l3.2188-3.2188ZM13.7814 6.0901c-.2929.2929-.7687.2938-1.0616.0009a.75.75 0 0 1 0-1.0607L17.7502 0l5.0299 5.0298c.2929.2929.2934.7683.0005 1.0612a.75.75 0 0 1-1.0607 0l-3.2197-3.2197V16.81c0 .4142-.3358.7508-.75.7508a.75.75 0 0 1-.75-.75V2.8713l-3.2188 3.2188Z"
    clipRule="evenodd"
  />,
  'Sort'
);
